"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var getState_1 = require("./utils/getState");
//Likely do not need all these polyfills
require("array-flat-polyfill");
require("core-js/features/symbol");
require("core-js/features/object");
require("core-js/features/function");
require("core-js/features/parse-int");
require("core-js/features/parse-float");
require("core-js/features/number");
require("core-js/features/math");
require("core-js/features/string");
require("core-js/features/date");
require("core-js/features/array");
require("core-js/features/regexp");
require("core-js/features/map");
require("core-js/features/weak-map");
require("core-js/features/set");
require("core-js/features/array");
require("whatwg-fetch");
require("url-search-params-polyfill");
require("promise-polyfill/src/polyfill");
var index_1 = require("./router/index");
require("./scss/index.scss");
var classnames_1 = require("classnames");
var Sentry = require("@sentry/browser");
require("./icons");
var react_error_boundary_1 = require("react-error-boundary");
var core_1 = require("@rradar/core");
var app = document.getElementById('root');
var MyComponent = /** @class */ (function (_super) {
    __extends(MyComponent, _super);
    function MyComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            url: '',
            menuOpen: false,
        };
        _this.toggleMenu = function () {
            _this.setState(function (prevState) {
                return {
                    menuOpen: !prevState.menuOpen,
                };
            });
        };
        _this.componentDidMount = function () { return __awaiter(_this, void 0, Promise, function () {
            var response, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch((0, getState_1.default)().api.endpoint + '/auth', {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2:
                        url = (_a.sent()).url;
                        this.setState({ url: url });
                        return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    MyComponent.prototype.render = function () {
        if ((0, getState_1.default)().sentry.enabled) {
            Sentry.init({ dsn: (0, getState_1.default)().sentry.dsn });
            var user_1 = (0, getState_1.default)().user;
            Sentry.configureScope(function (scope) {
                scope.setUser({
                    email: user_1 ? user_1.user_email : 'N/A',
                    username: user_1 ? "".concat(user_1.user_first_name, " ").concat(user_1.user_second_name) : 'N/A',
                    id: user_1 ? user_1.user_id : 'N/A',
                });
            });
        }
        return (React.createElement("div", { className: (0, classnames_1.default)({
                'site-container': true,
                'site-container-fixed': this.state.menuOpen,
            }) },
            React.createElement(index_1.default, { url: this.state.url, toggleMenu: this.toggleMenu, menuOpen: this.state.menuOpen }),
            React.createElement(core_1.ToastContainer, null)));
    };
    return MyComponent;
}(React.Component));
ReactDOM.render(React.createElement(react_error_boundary_1.ErrorBoundary, { fallbackRender: function (props) {
        return React.createElement(core_1.ErrorPage, { error_status: "Something went wrong.", error_message: "We are sorry for the inconvenience" });
    } },
    React.createElement(MyComponent, null)), app);
exports.default = MyComponent;
